import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  colorCell: {
    minWidth: (noRemoval) => noRemoval ? 48 : 90,
    width: (noRemoval) => noRemoval ? 48 : 90,
    marginLeft: 8,
  },
  labelCell: {
    minWidth: 120,
    width: 120,
    marginRight: 8,
  },
  sticky: {
    position: "sticky",
    bottom: -24,
    backgroundColor: theme.props.backgroundSecondary,
    paddingBottom: 8,
  },
  hover: {
    "&:not(:hover) .hoverIcon": {
      zIndex: -1,
      opacity: "0 !important",
    },
  }
}));

export default useStyle;